import { css, type Theme } from "@emotion/react";

export const row = (theme: Theme) => css`
  display: unset;
  height: unset;
  text-align: left;
  padding: 0.625rem 2rem;

  &:hover {
    background-color: ${theme.system.backgroundMuted};
  }

  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  &&&:not(:last-of-type) {
    margin-bottom: 0;
  }
`;

export const brandName = css`
  font-style: italic;
`;

export const highlightRow = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
`;
